import dayjs from 'dayjs';
import Lucide from '@/components/Base/Lucide';
import Button from '@/components/Base/Button';

const chartBox =
  'box rounded-xl border border-slate-200/60 dark:border-darkmode-400 p-3 h-[420px] shadow-sm flex flex-col';
const chartTitle =
  'text-sm font-semibold text-slate-600 dark:text-slate-300 text-left mb-2';

function Main() {
  const today = dayjs().format('YYYY-MM-DD');

  return (
    <div className="p-6">
      <div className="mt-1 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <div className="relative inline-flex">
            <Lucide
              icon="Calendar"
              className="absolute group-[.mode--light]:!text-slate-200 inset-y-0 left-0 z-10 w-4 h-4 my-auto ml-3 stroke-[1.3]"
            />
            <input
              type="text"
              readOnly
              value={`${today} - ${today}`}
              className="w-[270px] pl-9 pr-3 py-2 rounded-[0.5rem] group-[.mode--light]:!bg-white/[0.12] group-[.mode--light]:!text-slate-200 group-[.mode--light]:!border-transparent dark:group-[.mode--light]:!bg-darkmode-900/30 dark:!box text-sm border-0"
            />
          </div>
          <Button variant="primary" className="w-full sm:w-auto">
            <Lucide icon="Search" className="stroke-[1.3] w-4 h-4 mr-2" />
            Search
          </Button>
        </div>
        <div className="inline-flex items-center text-xs text-white/95">
          <Lucide icon="Clock3" className="stroke-[1.3] w-3.5 h-3.5 mr-2" />
          Last updated at {dayjs().format('HH:mm:ss')}
        </div>
      </div>

      <div className="space-y-5">
        <div className="mb-5">
          <div className="box rounded-xl border border-slate-200/60 dark:border-darkmode-400 px-6 py-5 shadow-sm flex flex-col sm:flex-row items-center gap-6 sm:gap-0 sm:divide-x divide-slate-200 dark:divide-darkmode-400">
            <div className="flex flex-1 items-center justify-center gap-3 sm:pr-6">
              <p className="text-sm font-medium text-slate-500 dark:text-slate-400 whitespace-nowrap">
                Total Submissions
              </p>
              <p className="text-3xl font-bold tabular-nums text-slate-800 dark:text-slate-100 flex-shrink-0">
                —
              </p>
            </div>
            <div className="flex flex-1 items-center justify-center sm:pl-6">
              <div className="inline-flex flex-col items-start gap-1">
                <div className="flex items-center gap-3">
                  <p className="text-sm font-medium text-slate-500 dark:text-slate-400 whitespace-nowrap">
                    Active Staff:
                  </p>
                  <span className="text-3xl font-bold tabular-nums text-slate-800 dark:text-slate-100">
                    —
                  </span>
                </div>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  Dashboard data coming soon
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5">
          <div className={chartBox}>
            <p className={chartTitle}>Submissions by Month</p>
            <div className="flex-1 min-h-0 flex items-center justify-center text-slate-400 text-sm">
              Chart data will appear here
            </div>
          </div>

          <div className={`${chartBox} h-auto min-h-[420px]`}>
            <p className={chartTitle}>Survey Overview</p>
            <div className="flex-1 min-h-0 flex items-center justify-center text-slate-400 text-sm">
              Chart data will appear here
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
